import React, { useEffect, useState, useRef } from 'react';
import {
    DialogTitle, DialogContent, DialogActions, Dialog, makeStyles, Paper, ClickAwayListener, MenuList, MenuItem, Card, CardContent,
    Popper,
    Grow,
    Divider
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import {
    INVOICE_STATUS
} from "../../../store/constants";
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";


const useStyles = makeStyles((theme) => ({

    filterButton: {
        textTransform: "capitalize",
        padding: "5px 10px",
        backgroundColor: "#fff",
        fontWeight: 300,
        paddingLeft: 16,
        borderRadius: '40px'
    },
    arrowDropDownIconV1: {
        marginTop: -1
    },
    arrowDropUpIconV1: {
        marginTop: -1
    },
    menuItemV1: {
        display: 'flex', justifyContent: 'flex-start', fontWeight: 300, paddingTop: 10, paddingBottom: 10
    },
    wV1: {
        width: '100%'
    },

}));

const InvoiceStatusFilter = ({ status }) => {

    const [open, setOpen] = useState(false);
    const [invoiceStatusValue, setInvoiceStatusValue] = useState("All Invoices");

    const anchorRef = React.useRef(null);
    const prevOpen = React.useRef(open);

    const classes = useStyles();

    useEffect(() => {

        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
        
    }, []);

    const handleFilterOpen = () => {
        setOpen(true);
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    }

    const handleCloseFilter = () => {
        setOpen(false);
    }

    const handleItemClick = (value) => {
        setInvoiceStatusValue(value.displayName);
        handleCloseFilter();
        status(value.value);
    }

    return (
        <>
            <Button
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                variant="outlined"
                size="small"
                className={classes.filterButton}
                onClick={handleFilterOpen}
                endIcon={
                    <ArrowDropDownIcon className={classes.arrowDropDownIconV1} />
                }
            >
                {invoiceStatusValue}
            </Button>

            {open &&
                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1000 }}>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList autoFocusItem={open} id="menu-list-grow">
                                        {INVOICE_STATUS.map((value, index) => (
                                            <div className={classes.wV1} >
                                                <MenuItem key={index} className={classes.menuItemV1} onClick={() => handleItemClick(value)}>{value && value.displayName ? value.displayName : ""}</MenuItem>
                                                <Divider light />
                                            </div>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            }
        </>
    )
}

export default InvoiceStatusFilter;